const TRUNCATE_PLACEHOLDER = '...';
const DEFAULT_MAX_LENGTH = 30;

export const truncateFileName = (fileName: string, maxLength = DEFAULT_MAX_LENGTH) => {
  if (!fileName || fileName.length <= maxLength) return fileName;

  const half = Math.floor((maxLength - TRUNCATE_PLACEHOLDER.length) / 2);
  return `${fileName.slice(0, half)}...${fileName.slice(fileName.length - half)}`;
};

/**
 * Trims a string and ensures it is never null or undefined, returning an empty string instead.
 * @param value - The potentially null, undefined, or string value.
 * @returns The trimmed string or an empty string ('').
 */
export const cleanString = (value: string | null | undefined): string => {
  if (typeof value === 'string') {
    return value.trim();
  }
  return '';
};
